<template>
  <div id="paginaVerificaBilancio">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Verifica Bilancio Ministero</b-card-title>
              <!-- <b-card-text class="mb-0"> Teatro Coccia </b-card-text> -->
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridA" ref="gridA" :dataSource="entrateBilancioMinistero" 
                  :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions"
                  :allowGrouping="true" :groupSettings="gridA.groupOptions">
                  <e-columns>
                    <e-column field="gruppo" width="100" visible="false"></e-column>
                    <e-column field="etichetta" headerText="Etichetta" width="100"></e-column>
                    <e-column field="preventivo" headerText="Prev" width="60"></e-column>
                    <e-column field="consuntivo" headerText="Cons" width="60"></e-column>
                    <e-column field="diff" headerText="Diff" width="60"></e-column>
                    <e-column field="diff_perc" headerText="Diff %" width="60"></e-column>
                  </e-columns>
                  <e-aggregates>
                    <e-aggregate>
                      <e-columns>
                        <e-column type="Sum" field="preventivo" format="Tot € ######.##"></e-column>
                        <e-column type="Sum" field="consuntivo" format="Tot € ######.##"></e-column>
                      </e-columns>
                    </e-aggregate>
                  </e-aggregates>
                </ejs-grid>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridB" ref="gridB" :dataSource="usciteBilancioMinistero" 
                  :toolbarClick="gridBClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions"
                  :allowGrouping="true" :groupSettings="gridA.groupOptions">
                  <e-columns>
                    <e-column field="gruppo" width="100" visible="false"></e-column>
                    <e-column field="etichetta" headerText="Etichetta" width="100"></e-column>
                    <e-column field="preventivo" headerText="Prev" width="60"></e-column>
                    <e-column field="consuntivo" headerText="Cons" width="60"></e-column>
                    <e-column field="diff" headerText="Diff" width="60"></e-column>
                    <e-column field="diff_perc" headerText="Diff %" width="60"></e-column>
                  </e-columns>
                  <e-aggregates>
                    <e-aggregate>
                      <e-columns>
                        <e-column type="Sum" field="preventivo" format="Tot € ######.##"></e-column>
                        <e-column type="Sum" field="consuntivo" format="Tot € ######.##"></e-column>
                      </e-columns>
                    </e-aggregate>
                  </e-aggregates>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
  Aggregate,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api

const apiBilancioAnnoUrl = '/demo/api/bilancioministero/export_verifica_bilancio'
// API ricerca distinte per anno

export default Vue.extend({
  components: {},
  data() {
    return {
      initial: true,
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      // praticheVVF
      entrateBilancioMinistero: [],
      usciteBilancioMinistero: [],
      tot_prev_entrate: 0,
      tot_cons_entrate: 0,
      tot_prev_uscite: 0,
      tot_cons_uscite: 0,

      // per inizializzazione dropdown a null
      initIndex: -1,
      // per gestione conto
      soggettiList: [],
      tipoFields: { text: "label", value: "val" },

      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      annoRiferimentoCorrente: null,
      // lista valori stato pratica

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Download riepilogo",
            tooltipText: "Download riepilogo",
            prefixIcon: "e-save",
            id: "download-riepilogo",
          },
          "Search",
        ],
        groupOptions: { showDropArea: false, columns: ['gruppo'] },
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      },
    };
  },
  created() {
    console.log("Pagina Verifica Bilancio Creata");
    // inizializzazione elenchi dal backend

  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Aggregate, Group],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    onAnnoRiferimentoChange: function (e) {
      console.log("Change")
      console.log("Recupero dati per l'anno selezionato");
      const datiDaInviare = { anno: this.annoRiferimentoCorrente, };
      useJwt.post(apiBilancioAnnoUrl, datiDaInviare).then((d) => {
        console.log("Dati bilancio")
        this.entrateBilancioMinistero = d.data['entrate'];
        this.usciteBilancioMinistero = d.data['uscite'];
        //this.$refs.gridA.ej2Instances.groupCollapseAll();
        this.entrateBilancioMinistero.forEach((obj) => {
          if (obj.preventivo) {
            this.tot_prev_entrate += (+obj.preventivo)
          }
          if (obj.consuntivo) {
            this.tot_cons_entrate += (+obj.consuntivo)
          }
        })
        this.usciteBilancioMinistero.forEach((obj) => {
          if (obj.preventivo) {
            this.tot_prev_uscite += (+obj.preventivo)
          }
          if (obj.consuntivo) {
            this.tot_cons_uscite += (+obj.consuntivo)
          }
        })
        console.log(`tot prev entrate ${this.tot_prev_entrate}`)
        console.log(`tot cons entrate ${this.tot_cons_entrate}`)
      });
      //this.$refs.gridA.ej2Instances.groupModule.collapseAll();
    },
    // per dialogA

    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "download") {
        // TODO da implementare
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          useJwt.post(apiDistinteGeneraUrl, {'id': selectedRow[0].id}).then((d) => {
            console.log(d.data)

            const nomeFile = d.data['fileDocumento'].split('\\').pop().split('/').pop().split('?')[0]
            
            const link = document.createElement("a");
            link.href = d.data['fileDocumento']
            link.setAttribute("download", nomeFile);
            document.body.appendChild(link);
            link.click();
          })
      }
    },
 
    gridBClickHandler(args) {
      // pulsante da implementare
      if (args.item.id === "new") {
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
